/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷可能フラグ（金曜日）
 * @export
 * @interface EnableShipdayFri
 */
export interface EnableShipdayFri {
}

/**
 * Check if a given object implements the EnableShipdayFri interface.
 */
export function instanceOfEnableShipdayFri(value: object): value is EnableShipdayFri {
    return true;
}

export function EnableShipdayFriFromJSON(json: any): EnableShipdayFri {
    return EnableShipdayFriFromJSONTyped(json, false);
}

export function EnableShipdayFriFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableShipdayFri {
    return json;
}

export function EnableShipdayFriToJSON(json: any): EnableShipdayFri {
    return EnableShipdayFriToJSONTyped(json, false);
}

export function EnableShipdayFriToJSONTyped(value?: EnableShipdayFri | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

